import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";
import styles from "../../pages/Settings/Settings.module.scss";

const EventType = ({
  apiAddFunc,
  buttonLabel,
  listComponent: ListComponent,
  editFormComponent: EditFormComponent,
  component,
  ...props
}) => {
  const [addnewform, setAddNewForm] = React.useState(false);

  const handleSubmit = async (data) => {
    const isActivity = component === "activityTypes";
    const label = isActivity ? "Activity Type" : "Time Type";

    try {
      await apiAddFunc(data);
      toast.success(`${label} Added Successfully`);
    } catch {
      toast.error(`Error occurred while adding ${label}`);
    } finally {
      setAddNewForm(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="row">
          <div className="col-lg-10 col-md-8"></div>
          <Button
            className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              setAddNewForm(true);
              props.open();
            }}
          >
            Add <br></br>
            {buttonLabel}
          </Button>
        </div>
        <div className="settings-grid-wrapper">
          <ListComponent />
        </div>
      </>
      {addnewform && (
        <EditFormComponent
          cancelEdit={() => {
            setAddNewForm(false);
          }}
          onSubmit={handleSubmit}
          type="addNew"
        />
      )}
    </React.Fragment>
  );
};

export default EventType;
